export default "__VITE_ASSET__D$Rw8Zyc__"